import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/utils/cn';

const badgeVariants = cva(
  'inline-flex items-center justify-center rounded-control border font-ui font-medium text-center whitespace-nowrap',
  {
    variants: {
      variant: {
        default: 'border-subtle bg-stone text-content-secondary',
        success: 'border-state-nominal/25 bg-state-nominal-soft text-state-nominal',
        warning: 'border-state-warning/25 bg-state-warning-soft text-state-warning',
        danger: 'border-state-critical/25 bg-state-critical-soft text-state-critical',
        info: 'border-hairline bg-paper text-content-secondary',
      },
      size: {
        sm: 'px-2.5 py-1 text-xs',
        md: 'px-3 py-1 text-sm',
        lg: 'px-4 py-1.5 text-base',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'md',
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {
  pulse?: boolean;
}

const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
  ({ className, variant, size, pulse = false, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(badgeVariants({ variant, size }), pulse && 'animate-status-breathe', className)}
      {...props}
    />
  )
);

Badge.displayName = 'Badge';

export { Badge, badgeVariants };
